import { USER_ROLE } from "../../../../../appConstants";
export const USER_ROLES_OPTION = [
  { label: USER_ROLE.PLANNER, value: USER_ROLE.PLANNER },
  { label: USER_ROLE.DISPATCHER, value: USER_ROLE.DISPATCHER },
  { label: USER_ROLE.ADMIN, value: USER_ROLE.ADMIN },
  { label: USER_ROLE.MANAGER, value: USER_ROLE.MANAGER },
  { label: USER_ROLE.READ_ONLY, value: USER_ROLE.READ_ONLY }
];
